// components/CustomMenu.js
import { Menu } from 'react-admin';
import { useResourceDefinitions } from 'react-admin';

export const CustomMenu = (props) => {
    const resources = useResourceDefinitions();
    
    // Список ресурсов, которые нужно скрыть
    const hiddenResources = ['schedules'];
    
    return (
        <Menu {...props}>
            {Object.keys(resources)
                .filter(name => !hiddenResources.includes(name))
                .map(name => (
                    <Menu.ResourceItem key={name} name={name} />
                ))}
        </Menu>
    );
};